module.exports = __webpack_public_path__ + "fonts/OpenSans-MediumItalic.5a85b425.ttf";